webpackJsonp([2],{

/***/ "0K5S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import axios from 'axios'
/* eslint no-useless-escape: "off" */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    var _this = this;

    return {
      preferredContact: 'phone',
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }, function (v) {
        return v && v.length <= 20 || 'Name must be less than 20 characters';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      phone: '',
      phoneRules: [function (v) {
        return !!v || 'Phone number is required';
      }],
      error: '',
      valid: false,
      validation: '',
      validationRules: [function (v) {
        return !!v || 'Are you a robot?';
      }, function (v) {
        return Number(_this.validation) === _this.formNumberOne + _this.formNumberTwo || 'Please enter sum of the two numbers';
      }],
      success: false
    };
  },

  computed: {
    formNumberOne: function formNumberOne() {
      return Math.floor(Math.random() * 100);
    },
    formNumberTwo: function formNumberTwo() {
      return Math.floor(Math.random() * 100);
    },
    formSolution: function formSolution() {
      if (Number(this.validation) === this.formNumberOne + this.formNumberTwo) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var submission = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        contact: this.preferredContact
      };
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('contact-form').push(submission);
      this.success = true;
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204ee0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("y+hr");
function injectStyle (ssrContext) {
  __webpack_require__("XQDU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204ee0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "7zck"));







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var config = {
  apiKey: 'AIzaSyCh57b0VKqNWYxnTRsBbhkk9ziRx4gH9G8',
  authDomain: 'kristenevansdot.firebaseapp.com',
  databaseURL: 'https://kristenevansdot.firebaseio.com',
  projectId: 'kristenevansdot',
  storageBucket: 'kristenevansdot.appspot.com',
  messagingSenderId: '1050597465193'
};

__WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](config);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "XQDU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ "atkd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mortgagebrokers.c150c82.jpg";

/***/ }),

/***/ "hLJ3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kristenlogo.b2a75dd.png";

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3b7afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("u3DM");
function injectStyle (ssrContext) {
  __webpack_require__("0K5S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae3b7afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3b7afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u3DM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"showcase"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg4":"","offset-lg1":""}},[_c('div',{staticClass:"box sidebar text-xs-center"},[_c('div',{staticClass:"logo "},[_c('img',{attrs:{"src":__webpack_require__("hLJ3"),"alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("atkd"),"alt":""}})]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.success)?_c('div',[_c('h1',[_vm._v("Free Pre-Approval")]),_vm._v(" "),_c('h3',[_vm._v("Please fill out the form below and I will contact you shortly.")]),_vm._v(" "),_c('v-form',{ref:"contact-form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"dark":"","color":"deep-orange lighten-1","rules":_vm.nameRules,"label":"Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","validate-on-blur":"","rules":_vm.emailRules,"dark":"","color":"deep-orange lighten-1","label":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"mask":"phone","required":"","validate-on-blur":"","rules":_vm.phoneRules,"dark":"","color":"deep-orange lighten-1","label":"Phone Number"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"validate-on-blur":"","rules":_vm.validationRules,"dark":"","color":"deep-orange lighten-1","label":'Are you a human? What is ' + _vm.formNumberOne + ' + ' + _vm.formNumberTwo + ' = ? '},model:{value:(_vm.validation),callback:function ($$v) {_vm.validation=$$v},expression:"validation"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-checkbox',{attrs:{"label":"Phone","color":"deep-orange lighten-1","value":"phone","dark":""},model:{value:(_vm.preferredContact),callback:function ($$v) {_vm.preferredContact=$$v},expression:"preferredContact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-checkbox',{attrs:{"label":"Text","color":"deep-orange lighten-1","value":"text","dark":""},model:{value:(_vm.preferredContact),callback:function ($$v) {_vm.preferredContact=$$v},expression:"preferredContact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-checkbox',{attrs:{"color":"deep-orange lighten-1","label":"Email","value":"email","dark":""},model:{value:(_vm.preferredContact),callback:function ($$v) {_vm.preferredContact=$$v},expression:"preferredContact"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","block":"","color":"deep-orange lighten-1","disabled":!_vm.valid},on:{"click":_vm.onSubmit}},[_vm._v("Submit")])],1),_vm._v(" "),_c('v-divider',{attrs:{"dark":""}}),_vm._v(" "),_c('br')],1):_c('div',[_c('v-divider',{attrs:{"dark":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',[_vm._v("Thank you. I'll "+_vm._s(_vm.preferredContact)+" you soon!")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-divider',{attrs:{"dark":""}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('div',{staticClass:"text-xs-left"},[_c('h3',[_vm._v("Kristen Evans")]),_vm._v(" "),_c('h4',[_vm._v("MBA, Associate Lending Manager")]),_vm._v(" "),_c('h4',[_vm._v("NMLS #289464")]),_vm._v(" "),_c('h4',[_vm._v("kristen@kristenevans.net")]),_vm._v(" "),_c('h4',[_vm._v("801.913.7367")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('div',{staticClass:"text-xs-left"},[_c('h3',[_vm._v("Mortgage Brokers, LLC")]),_vm._v(" "),_c('h4',[_vm._v("NMLS #1157639")]),_vm._v(" "),_c('h4',[_vm._v("4252 S Highland Drive suite 104")]),_vm._v(" "),_c('h4',[_vm._v("Salt Lake City, UT 84124 ")])])])],1)],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"box greeting text-xs-center hidden-md-and-down"},[_c('h1',[_vm._v("Professional... Affordable... Local")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Talk to a real person not a computer")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"text-xs-left"},[_vm._v("With over a decade doing loans in the Utah market, I know what it takes to get you the best loan. I've saved my clients millions over the life of their loans and have made friendships that will last forever. Contact me today to see what I can do for you.")])])]),_vm._v(" "),_c('v-spacer')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "y+hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-content',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.397455c5b9bca68053d1.js